import RouteEnum from '~/enums/RouteEnum';
import auth from '~/routes/auth';
import tos from '~/routes/tos';

export default () => [...auth, ...tos];
